module.exports = __webpack_public_path__ + "img/Dashboard_B.9c6899a9.svg";